import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Wifi, Bot, Users, Zap, CheckCircle2, Circle, ArrowRight } from 'lucide-react';

const STEPS = [
  { key: 'whatsapp', label: 'WhatsApp conectado', icon: Wifi },
  { key: 'ai', label: 'Asistente IA activo', icon: Bot },
  { key: 'assignment', label: 'Vendedores asignados', icon: Users },
  { key: 'live_test', label: 'Prueba en vivo', icon: Zap },
];

export default function AIQuickStart() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    api.get('/tenant/lead-attendance/setup-status').then(r => setStatus(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6" data-testid="ai-quick-start">
      <div>
        <h2 className="text-base font-semibold text-[#0F172A]">Inicio rápido</h2>
        <p className="text-sm text-[#64748B]">¿Solo quieres que la IA atienda WhatsApp? Sigue estos pasos.</p>
      </div>

      <div className="bg-white border border-[#E2E8F0] rounded-xl p-4 space-y-3">
        {STEPS.map(s => {
          const ok = status?.steps?.[s.key]?.status === 'ok';
          return (
            <div key={s.key} className="flex items-center gap-3">
              {ok ? <CheckCircle2 className="w-4 h-4 text-emerald-600" /> : <Circle className="w-4 h-4 text-[#CBD5E1]" />}
              <s.icon className="w-4 h-4 text-[#64748B]" />
              <span className={`text-sm ${ok ? 'text-emerald-700' : 'text-[#64748B]'}`}>{s.label}</span>
            </div>
          );
        })}
      </div>

      <Button onClick={() => navigate('/tenant/setup')} className="bg-[#0F172A] text-white w-full">
        Abrir checklist completo <ArrowRight className="w-4 h-4 ml-1" />
      </Button>

      <div className="grid grid-cols-3 gap-2">
        <Button variant="outline" size="sm" onClick={() => navigate('/tenant/integrations?modal=evolution')}>Conectar WhatsApp</Button>
        <Button variant="outline" size="sm" onClick={() => navigate('/tenant/ai/training')}>Personalidad IA</Button>
        <Button variant="outline" size="sm" onClick={() => navigate('/tenant/business/team')}>Vendedores</Button>
      </div>
    </div>
  );
}
